/* tourist/voc */
import qs from 'qs'
import instance from '@/helpers/axios'
import numeral from 'numeral'

const state = {
    voc_pub_beginDate: null,
    voc_pub_lastDate: null,
    voc_pub_datasets: [],
    voc_pub_proportion_channels: [],
    voc_pub_proportion_purpose_v1: [],
    voc_pub_proportion_purpose_v2: [],
    voc_pub_country: [],
    voc_pub_country_filter: null,
    //v2
    voc_pub_isLoading: false,
    voc_pub_channel: {},
    voc_pub_sentiment_x_location_destination: {},
    voc_pub_purpose: {},
    voc_pub_purpose_x_date: {},
}

// getters
const getters = {
    voc_pub_date: state => {
        if (state.voc_pub_beginDate != null) {
            var _start = state.voc_pub_beginDate.split("T");
            var _end = state.voc_pub_lastDate.split("T")
            return { start: _start[0], end: _end[0] }
        } else {
            return { start: state.voc_pub_beginDate, end: state.voc_pub_lastDate }
        }
    },
    voc_pub_isLoading: state => {
        return state.voc_pub_isLoading;
    },
    voc_pub_data_date: state => {
        if (state.voc_pub_beginDate !== null) {
            var _start = state.voc_pub_beginDate.split("T");
            var _end = state.voc_pub_lastDate.split("T")
            return _start[0] + " to " + _end[0];
        }else{
            return "N/A"
        }        
    },
    voc_pub_datasets: state => {
        return state.voc_pub_datasets;
    },
    voc_pub_proportion_channels: state => {
        return state.voc_pub_proportion_channels;
    },
    voc_pub_proportion_purpose_v1: state => {
        return state.voc_pub_proportion_purpose_v1;
    },
    voc_pub_proportion_purpose_v2: state => {
        return state.voc_pub_proportion_purpose_v2;
    },
    voc_pub_country: state => {
        return state.voc_pub_country;
    },
    voc_pub_country_filter: state => {
        return state.voc_pub_country_filter;
    }
}

// actions
const actions = {
    // start /v2 actions
    V2getVocDatasetsPub(context, payload) {
        state.voc_pub_isLoading = true;
        state.voc_pub_country_filter = null;
        var _params = {};
        // calulate _params from main_filters                
        var main_filters = payload.main_filters;
        if (main_filters !== null) {
            if (main_filters.start !== null && main_filters.end !== null) {
                _params.start = new Date(main_filters.start).setUTCHours(0, 0, 0, 0);
                _params.end = new Date(main_filters.end).setUTCHours(23, 59, 59, 999);
            }
            if (main_filters.location_source !== null) {
                _params.location_source = main_filters.location_source;
            }
            if (main_filters.location_destination != null) {
                _params.location_destination = main_filters.location_destination;
            }
        }
        const request = {
            params: qs.parse(_params)
        };
        // query data
        instance.get('v2/tourist/voc/public', request)
            .then(response => {
                const {
                    date,
                    voc_channel,
                    voc_sentiment_x_location_destination,
                    voc_purpose,
                    voc_purpose_x_date
                } = response.data;

                state.voc_pub_beginDate = date.start;
                state.voc_pub_lastDate = date.end;
                state.voc_pub_channel = voc_channel;
                // will fixed name from api. (voc_pub_channel=>voc_sentiment)
                state.voc_pub_sentiment_x_location_destination = voc_sentiment_x_location_destination;
                state.voc_pub_purpose = voc_purpose;
                state.voc_pub_purpose_x_date = voc_purpose_x_date;

                payload.stateDatasets.forEach(function(stateName) {
                  if (stateName == "voc_pub_proportion_channels") {
                        context.commit("V2onVocProportionChannelPub", payload);
                    } else if (stateName == "voc_pub_country") {
                        context.commit("V2onVocCountryPub", payload);
                    } else if (stateName == "voc_pub_proportion_purpose_v1") {
                        context.commit("V2onVocProportionPurposeV1Pub", payload);
                    } else if (stateName == "voc_pub_proportion_purpose_v2") {
                        context.commit("V2onVocProportionPurposeV2Pub", payload);
                    }
                })

                state.voc_pub_isLoading = false;
            })
            .catch(error => {
                console.log(error.response, "[store/v2/tourist/voc/public] syntax errors under instant.get");
            })
    },
    V2getVocCountryFilterPub(context, payload) {
        state.voc_pub_isLoading = true;
        if (payload.sentiment !== undefined) {
            if (payload.sentiment !== null) {
                var rows = state.voc_pub_sentiment_x_location_destination.rows;
                var rows_filtered = [];
                rows.forEach(function(item, index) {
                    if (item._id.voc_sentiment == payload.sentiment) {
                        rows_filtered.push(item);
                    }
                });
                payload.rows_filtered = rows_filtered;
            } else {
                payload.rows_filtered = state.voc_pub_sentiment_x_location_destination.rows;
            }
            context.commit("V2onVocCountryPub", payload);
        }
        state.voc_pub_isLoading = false;
    },
    getVocDatasetsPub(context, payload) {
        console.log("[store/tourist/voc/public] getVocDatasets() DEPRECATED");
        return;
    },
    getVocCountryFilterPub(context, payload) {
        console.log("[store/tourist/voc/public] getVocCountryFilter() DEPRECATED");
        return;
    }
}

// mutations
const mutations = {
    // start /v2 mutations
    V2onVocProportionChannelPub(state, payload) {
        // --- start dataset for doughnut chart
        // items = [{data:number,label:string,color:string}]
        // const colors = [
        //     '#3241a6', //blue
        //     '#578e47', //green
        //     '#cf9a41', //yellow
        //     '#be4141', //red
        //     '#7d3b98', //purple
        // ]; 
        var colors = [];
        colors['facebook'] = '#3241a6';
        colors['instagram'] = '#578e47';
        colors['twitter'] = '#cf9a41';
        colors['webboard'] = '#be4141';
        colors['website'] = '#7d3b98';
        colors['youtube'] = '#e5e5e5';

        var rows = state.voc_pub_channel.rows;
        var total = 0;
        var items = [];
        
        rows.forEach(function(item, index) {
            total += item.sum_voc;
            var _color = "#e5e5e5";
            if (colors[item._id.voc_channel] !== undefined) {
                _color = colors[item._id.voc_channel];
            }
            // var percentage = (item.sum_voc / total * 100).toFixed(2);
            // var label = item._id.voc_channel.toUpperCase() + " " + percentage + "% " + numeral(item.sum_voc).format('0,0');
            var label = item._id.voc_channel.toUpperCase();
            var _item = { "data": item.sum_voc, "label": label, color: _color };

            if (item.sum_voc > 0){
              items.push(_item);
            }
        });

        items.sort(function(a, b) {
            return a.label.localeCompare(b.label);
        })
        state.voc_pub_proportion_channels = items
        // --- end dataset for doughnut chart
    },
    V2onVocProportionPurposeV1Pub(state, payload) {
        // --- start dataset doughnut for chart
        // items = [{data:0,label:'label'}]
        var colors = [];
        colors['general'] = '#3241a6';
        colors['question'] = '#578e47';
        colors['enquiries'] = '#cf9a41';
        colors['admire'] = '#be4141';
        colors['complaint'] = '#7d3b98';

        var rows = state.voc_pub_purpose.rows;
        var total = 0;
        var items = [];
        for (var key in colors) {
            items.push({ color: colors[key], data: 0, "label": key.toUpperCase() });
        }

        rows.forEach(function(item, index) {
            total += item.sum_voc;
        });

        rows.forEach(function(item, index) {
            var _color = "#e5e5e5";
            if (colors[item._id.voc_purpose] !== undefined) {
                _color = colors[item._id.voc_purpose];
            }
            // var percentage = (item.sum_voc / total * 100).toFixed(2);
            // var label = item._id.voc_purpose.toUpperCase() + " " + percentage + "% " + numeral(item.sum_voc).format('0,0');
            var label = item._id.voc_purpose.toUpperCase();
            var _item = { "data": item.sum_voc, "label": label, color: _color };

            // sort by user defined - colors array
            var _index = 0;
            for (var key in colors) {
                if (key == item._id.voc_purpose) {
                    items[_index] = _item;
                }
                _index++;
            }
        });
        // check total
        if (total == 0) {
            items = [];
        }
        state.voc_pub_proportion_purpose_v1 = items
        // --- end dataset for doughnut chart
    },
    V2onVocProportionPurposeV2Pub(state, payload) {
        // --- start dataset for stack chart
        // items = [{label1:0,label2:0,...,date:string}]
        var total = 0;
        var colors = [];
        colors['GENERAL'] = '#3241a6';
        colors['QUESTION'] = '#578e47';
        colors['ENQUIRIES'] = '#cf9a41';
        colors['ADMIRE'] = '#be4141';
        colors['COMPLAINT'] = '#7d3b98';

        var rows = state.voc_pub_purpose_x_date.rows;
        var items = [];
        rows.forEach(function(item, index) {
            total += item.sum_voc;
            var _item = {};
            var _voc_pub_purpose = item._id.voc_purpose.toUpperCase();
            var pos = items.map(function(e) {
                return e.date;
            }).indexOf(item._id.date);
            if (pos == -1) {
                _item['date'] = item._id.date;
                _item['GENERAL'] = 0;
                _item['QUESTION'] = 0;
                _item['ENQUIRIES'] = 0;
                _item['ADMIRE'] = 0;
                _item['COMPLAINT'] = 0;
                _item[_voc_pub_purpose] = item.sum_voc;
                items.push(_item);
            } else {
                _item = items[pos];
                if (_item[_voc_pub_purpose] != undefined) {
                    _item[_voc_pub_purpose] += item.sum_voc;
                } else {
                    _item[_voc_pub_purpose] = item.sum_voc;
                }
                items[pos] = _item;
            }
        });

        // sort by date desc        
        items.sort(function(a, b) {
            var _a = parseInt(a.date.split("-").join(""));
            var _b = parseInt(b.date.split("-").join(""));
            return _a - _b;
        });

        // attached colors 
        items.push(colors);

        if (total == 0) {
            items = [];
        }
        state.voc_pub_proportion_purpose_v2 = items
        // --- end dataset for stack chart
    },
    V2onVocCountryPub(state, payload) {
        // --- start dataset for jvector map
        // items = [{label1:0,label2:0,...,data:0,label:'',location_destination:'',percentage:'',filter_voc_sentiment:null},...]
        var rows = state.voc_pub_sentiment_x_location_destination.rows;
        var items = [];
        var total = 0;

        // on filtered load raw data from payload.rows_filtered
        if (payload.rows_filtered !== undefined) {
            rows = payload.rows_filtered;
        }

        var _filter_voc_sentiment = null;
        var _filter_voc_sentiment_total = 0;
        rows.forEach(function(item, index) {
            var _item = {};
            var _voc_sentiment = item._id.voc_sentiment.toUpperCase();
            var pos = items.map(function(e) {
                return e.location_destination;
            }).indexOf(item._id.location_destination);

            total += item.sum_voc;
            if (pos == -1) {
                _item['label'] = item._id.location_destination;
                _item['location_destination'] = item._id.location_destination;
                _item['data'] = item.sum_voc;
                _item['POSITIVE'] = 0;
                _item['NEGATIVE'] = 0;
                _item['NEUTRAL'] = 0;
                _item[_voc_sentiment] = item.sum_voc;

                items.push(_item);
            } else {
                items[pos]['data'] += item.sum_voc;;
                items[pos][_voc_sentiment] += item.sum_voc;
            }

            if (_filter_voc_sentiment !== null) {
                if (_filter_voc_sentiment == _voc_sentiment) {
                    _filter_voc_sentiment_total += item.sum_voc;
                }
            }
        });

        items.forEach(function(item, index) {
            var _data = item.data;
            var _total = total;
            var percentage;
            if (_filter_voc_sentiment !== null) {
                _data = item[_filter_voc_sentiment];
                _total = _filter_voc_sentiment_total;
            }
            percentage = ((_data / _total) * 100);
            items[index].filter_voc_sentiment = _filter_voc_sentiment;
            items[index].data = _data;
            items[index].percentage = percentage;
            items[index].location_destination = items[index].label;
            items[index].label = item.label.toUpperCase() + " " + numeral(percentage).format('0,0.00') + "% (" + numeral(item.data).format('0,0') + ")";
        });

        if (total == 0) {
            items = [];
        }

        // on filtered save items data to voc_pub_country_filter
        if (payload.rows_filtered !== undefined) {
            state.voc_pub_country_filter = items;
        } else {
            state.voc_pub_country = items;
        }
        // --- end dataset for jvector map
    },
}

export default {
    state,
    getters,
    actions,
    mutations
}